"use server";

import { redirect } from "next/navigation";
import { setJwt } from "@/lib/auth";

export type RegisterState = { error?: string };

export async function registerAction(
  _prev: RegisterState,
  formData: FormData
): Promise<RegisterState> {
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;
  const tenantName = formData.get("tenantName") as string;
  const locale = (formData.get("locale") as string) || "de";

  if (!email || !password || !tenantName) {
    return { error: "serverError" };
  }

  let jwt: string;
  try {
    const res = await fetch(
      `${process.env.STRAPI_INTERNAL_URL ?? "http://strapi:1337"}/api/tenants/register`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, tenantName }),
        cache: "no-store",
      }
    );

    const data = await res.json();

    if (!res.ok) {
      const msg: string = data?.error?.message ?? "";
      if (msg.toLowerCase().includes("email")) {
        return { error: "emailTaken" };
      }
      return { error: "serverError" };
    }

    jwt = data.jwt;
  } catch {
    return { error: "serverError" };
  }

  await setJwt(jwt);
  redirect(`/${locale}/dashboard`);
}
